import { useState, useEffect } from 'react'
import { Modal, Button, Typography } from 'antd'
import { ExclamationCircleOutlined } from '@ant-design/icons'
import { sessionManager } from '../../utils/session'

const { Text } = Typography

interface SessionTimeoutModalProps {
  visible: boolean
  onExtend: () => void
  onLogout: () => void
}

const SessionTimeoutModal = ({ 
  visible, 
  onExtend, 
  onLogout 
}: SessionTimeoutModalProps) => {
  const [remainingTime, setRemainingTime] = useState('')
  
  useEffect(() => {
    if (!visible) return
    
    // Update remaining time every second
    const interval = setInterval(() => {
      const time = sessionManager.getFormattedRemainingTime()
      setRemainingTime(time)
      
      // Auto logout if time runs out
      if (sessionManager.getRemainingTime() <= 0) {
        onLogout()
      }
    }, 1000)
    
    return () => clearInterval(interval)
  }, [visible, onLogout])
  
  const handleExtend = () => {
    sessionManager.extendSession()
    onExtend()
  }
  
  return (
    <Modal
      title={
        <div className="flex items-center gap-2">
          <ExclamationCircleOutlined className="text-yellow-500" />
          <span>Session Expiring Soon</span>
        </div>
      }
      open={visible}
      closable={false}
      maskClosable={false}
      footer={[
        <Button key="logout" onClick={onLogout}>
          Log Out Now
        </Button>,
        <Button key="extend" type="primary" onClick={handleExtend}>
          Continue Session
        </Button>,
      ]}
    >
      <div className="text-center py-4">
        <Text>
          Your session will expire in <Text strong>{remainingTime}</Text>.
        </Text>
        <br />
        <Text className="text-gray-600">
          Would you like to continue working?
        </Text>
      </div>
    </Modal>
  )
}

export default SessionTimeoutModal